import Button from '@ui/button/Button';
import Loading from '@ui/loading/Loading';
import { Autocomplete } from '@react-google-maps/api';
import React, { useEffect, useState, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import analyticsUtils from '../../scripts/utilities/analyticsUtils';
const ConnectivityForm = (props) => {
    const { t, connectivityFormResponse } = props;
    const [submitting, setSubmitting] = useState(false);
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [error, setError] = useState();
    const connectivityFormRef = useRef(null);
    const inputRef = useRef(null);
    const onLoad = (autocomplete) => (inputRef.current = autocomplete);
    useEffect(() => {
        if (!connectivityFormResponse) {
            setSubmitting(false);
        }
    }, [connectivityFormResponse]);
    //googledisabled check su t o f
    const onPlaceChanged = () => {
        if (inputRef.current) {
            const selectedPlaceObj = inputRef.current.getPlace();
            if (!selectedPlaceObj || !selectedPlaceObj.formatted_address) {
                setError(t('connectivity.error.address'));
                setSelectedPlace(null);
                return;
            }
            setSelectedPlace(selectedPlaceObj);
            setError('');
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSubmitting(true);
        let connectivityValue = new FormData(e.target).get('connectivity');
        if (!connectivityValue) {
            setError(t('required.field'));
            setSubmitting(false);
            return;
        }
        if (!selectedPlace) {
            let manualAddressParsed = parseAddress(connectivityValue);
            if (!manualAddressParsed) {
                setError(t('connectivity.form.notfound'));
                setSubmitting(false);
                return;
            }
            if (manualAddressParsed && manualAddressParsed.streetType && manualAddressParsed.streetName && manualAddressParsed.number && manualAddressParsed.city) {
                let pid = document.querySelector('.connectivity-container').getAttribute('data-pid');
                let data = {
                    'forcedPipeline': 'ConnectivityVerify',
                    'pid': pid
                };
                analyticsUtils.passThroughProcessor(data);
                props.setConnectivityForm({
                    city: manualAddressParsed.city,
                    address: manualAddressParsed.streetType + ' ' + manualAddressParsed.streetName,
                    civic: manualAddressParsed.number,
                });
                return;
            }
            else {
                setError(t('connectivity.form.notfound'));
                setSubmitting(false);
                return;
            }
        }
        let address = getStreetAndCity(selectedPlace);
        if (!address) {
            return;
        }
        if (address && address.city && address.street) {
            let pid = document.querySelector('.connectivity-container').getAttribute('data-pid');
            let data = {
                'forcedPipeline': 'ConnectivityVerify',
                'pid': pid
            };
            analyticsUtils.passThroughProcessor(data);
            props.setConnectivityForm({ city: address.city, address: address.street, civic: address.civic });
            return;
        }
    };
    function parseAddress(input) {
        const streetIdentifiers = [
            "Via", "Viale", "Piazza", "Corso", "Strada", "Largo", "Piazzale", "Vicolo", "Borgo",
            "Traversa", "Rione", "Salita", "Discesa", "Calata", "Contrada", "Frazione", "Molo",
            "Ripa", "Rotonda", "Rio", "Sestiere", "Piazzetta", "Campiello", "Calle", "Fondaco",
            "Stradone", "Riviera", "Galleria", "Passeggiata"
        ];
        const regex = new RegExp(`^(${streetIdentifiers.join('|')})\\s+(.*?)\\s+(\\d+)[,\\s]*(?:\\d*)\\s*(.+)$`, 'i');
        const match = input.match(regex);
        if (match) {
            return {
                streetType: match[1].trim().replace(',', ' '),
                streetName: match[2].trim().replace(',', ' '),
                number: match[3].trim().replace(',', ' '),
                city: match[4].trim().replace(',', ' '),
            };
        }
        return null;
    }
    const getStreetAndCity = (selectedPlace) => {
        let street = null;
        let city = null;
        let civic = '';
        if (selectedPlace && selectedPlace.address_components) {
            selectedPlace.address_components.forEach((component) => {
                if (component.types.includes('route')) {
                    street = component.long_name;
                }
                else if (component.types.includes('locality')) {
                    city = component.long_name;
                }
                else if (component.types.includes('street_number')) {
                    civic = component.long_name;
                }
            });
        }
        return { street, city, civic };
    };
    return (React.createElement("div", { className: "form-section" },
        React.createElement("form", { action: "#", method: "get", ref: connectivityFormRef, onSubmit: handleSubmit },
            React.createElement("div", { role: "combobox", className: "search-address--autocomplete" },
                React.createElement("div", { className: "custom-info" },
                    React.createElement("p", { className: "info-mandatory-label" }, t('connectivity.form.suggestion'))),
                props.googledisabled ? (React.createElement("div", { className: classNames('form-group', 'connectivity-input-container', { 'is-invalid': error }) },
                    React.createElement("input", { type: "text", name: "connectivity", id: "connectivity", className: "form--control label-up", "aria-required": "true", placeholder: t('label.placeholder.connectivityaddress'), onChange: () => {
                            setError('');
                            setSelectedPlace(null);
                        } }),
                    React.createElement("label", { id: "connectivity-label", className: "form-group-label", htmlFor: "connectivity" },
                        t('label.connectivity.input'),
                        "*"),
                    error && (React.createElement("div", { id: "connectivity-error", className: "invalid--feedback" }, error)))) : (React.createElement(Autocomplete, { onLoad: onLoad, onPlaceChanged: onPlaceChanged, types: ['street_address', 'route'], restrictions: { country: window.country } },
                    React.createElement("div", { className: classNames('form-group', 'connectivity-input-container', { 'is-invalid': error }) },
                        React.createElement("input", { type: "text", name: "connectivity", id: "connectivity", className: "form--control label-up", "aria-required": "true", placeholder: t('label.placeholder.connectivityaddress'), onChange: () => {
                                setError('');
                                setSelectedPlace(null);
                            } }),
                        React.createElement("label", { id: "connectivity-label", className: "form-group-label", htmlFor: "connectivity" },
                            t('label.connectivity.input'),
                            "*"),
                        error && (React.createElement("div", { id: "connectivity-error", className: "invalid--feedback" }, error))))),
                React.createElement("p", { className: "info-mandatory-label" }, t('label.info.mandatory'))),
            React.createElement(Button, { type: "submit", cls: ['cta-primary'], isAnimated: true, style: { pointerEvents: submitting ? 'none' : 'initial', cursor: submitting ? 'not-allowed' : 'pointer' } },
                submitting && React.createElement(Loading, { inline: true }),
                React.createElement("span", { style: { opacity: submitting ? 0 : 1 } }, t('connectivity.cta.form.verify'))))));
};
export default withTranslation()(ConnectivityForm);
